import type { ReactNode } from "react";

/** The centered card of the sign-in and consent screens. */
export function AuthCard({ children }: { children: ReactNode }) {
  return <div className="auth-card">{children}</div>;
}
